import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import PageWrapper from './components/PageWrapper.jsx';
import Home from './components/pages/Home.jsx';
import Contact2Us from './components/common/Contact2Us.jsx';
import About from './components/common/About.jsx';
import Blog from './components/common/Blog.jsx';
import Tools from './components/common/Tools.jsx';
import Login from './components/pages/Login.jsx';
import Signup from './components/pages/Signup.jsx';
import PasswordReset from './components/pages/PasswordReset.jsx';
import Newsletter from './components/common/News.jsx';
function App() {
  return (
    <div className="App">
      <Router>
        <PageWrapper>
          <Routes>
            <Route exact path='/' element={<Home/>}></Route>
            <Route exact path='/tools' element={<Tools/>}></Route>
            <Route exact path='/news' element={<Newsletter/>}></Route>
            <Route exact path='/blog' element={<Blog/>}></Route>
            <Route exact path='/about' element={<About/>}></Route>
            <Route exact path='/contact' element={<Contact2Us/>}></Route>
            <Route exact path='/login' element={<Login/>}></Route>
            <Route exact path='/signup' element={<Signup/>}></Route>
            <Route exact path='/passwordreset' element={<PasswordReset/>}></Route>
            <Route path='*' element={<Home/>}></Route>
          </Routes>
        </PageWrapper>
      </Router>
    </div>
  );
}

export default App;
